import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <motion.footer
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="bottom-0 left-0 right-0 z-40 flex justify-center pointer-events-none"
    >
      <div className="pointer-events-auto transition-all duration-500 w-[95%] md:w-[90%] max-w-7xl mb-4">
        <div className="py-2 bg-white/70 dark:bg-gray-900/70 backdrop-blur-md rounded-xl border border-white/20 dark:border-gray-800/30 shadow-sm overflow-hidden">
          <div className="px-4 py-2.5">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
              {/* Left Side - Logo & Copyright */}
              <div className="flex items-center gap-3">
                <Link to="/" className="flex items-center gap-1.5 group">
                  <div className="bg-white/40 dark:bg-gray-800/40 backdrop-blur-md rounded-md shadow-sm transition-all border border-white/50 dark:border-gray-700/50 flex items-center justify-center w-5 h-5">
                    <img
                      src="/Icon.png"
                      alt="TradeBridge Logo"
                      className="w-3.5 h-3.5 object-contain"
                    />
                  </div>
                  <span className="text-xs font-semibold text-gray-700 dark:text-gray-300">
                    Trade<span className="text-primary-600">Bridge</span>
                  </span>
                </Link>
                <span className="text-[10px] text-gray-400">•</span>
                <span className="text-[10px] text-gray-500">
                  © {currentYear}
                </span>
              </div>

              {/* Center - Quick Links */}
              <div className="flex items-center gap-3">
                <Link
                  to="/privacy"
                  className="text-[10px] text-gray-500 hover:text-primary-600 transition-colors"
                >
                  Privacy
                </Link>
                <span className="text-[10px] text-gray-400">•</span>
                <Link
                  to="/terms"
                  className="text-[10px] text-gray-500 hover:text-primary-600 transition-colors"
                >
                  Terms
                </Link>
                <span className="text-[10px] text-gray-400">•</span>
                <Link
                  to="/support"
                  className="text-[10px] text-gray-500 hover:text-primary-600 transition-colors"
                >
                  Support
                </Link>
              </div>

              {/* Right Side - Social & Status */}
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2.5">
                  <a
                    href="https://facebook.com/share/1cPzsK8Pv5/"
                    className="text-gray-400 hover:text-primary-600 transition-colors"
                  >
                    <Facebook size={10} />
                  </a>
                  <a
                    href="https://x.com"
                    className="text-gray-400 hover:text-primary-600 transition-colors"
                  >
                    <Twitter size={10} />
                  </a>
                  <a
                    href="https://www.instagram.com/tradebridge.export"
                    className="text-gray-400 hover:text-primary-600 transition-colors"
                  >
                    <Instagram size={10} />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/trade-bridge-export-253551432"
                    className="text-gray-400 hover:text-primary-600 transition-colors"
                  >
                    <Linkedin size={10} />
                  </a>
                </div>
                <div className="flex items-center gap-1">
                  <div className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse" />
                  <span className="text-[9px] text-gray-500">Live</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
